module.exports = __webpack_public_path__ + "img/part2.f136c801.png";